const TYPES: Record<string, string> = {
    bool: 'b',
    int: 'i',
    float: 'f',
    time: 't',
};

export default TYPES;
